var c = function() {
  return c = Object.assign || function(s) {
    for (var r, e = 1, t = arguments.length; e < t; e++) {
      r = arguments[e];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (s[n] = r[n]);
    }
    return s;
  }, c.apply(this, arguments);
};
function l(s, r, e) {
  if (e || arguments.length === 2) for (var t = 0, n = r.length, a; t < n; t++)
    (a || !(t in r)) && (a || (a = Array.prototype.slice.call(r, 0, t)), a[t] = r[t]);
  return s.concat(a || Array.prototype.slice.call(r));
}
export {
  c as __assign,
  l as __spreadArray
};
//# sourceMappingURL=index.es252.js.map
